import SkeletonLoader from "./skeleton_loader";
import CountryProductButton from "./country_product_button";
import ImageLoader from "./image_loader";
import {CatalogContext} from "./catalog_context";
const staticFeature = catalogModule.getUrl("static_feature");
const freeAddonText = gettext("Free with subscription plan");
const readMoreText = gettext("Read More");

const CountryProduct = (props) => {
    let catalogCtx = React.useContext(CatalogContext);
    const { catalog_data } = catalogCtx;
    const [showText, setShowText] = React.useState(false);
    const [addonProduct, setAddonProduct] = React.useState({});
    const [isLoading, setLoading] = React.useState(false);
    // const [isImageLoaded, setImageLoaded] = React.useState(false);
    let productObj = checkCurrencyReact(addonProduct);
    // let productInfo = addonProduct && addonProduct.info ? JSON.parse(addonProduct.info) : '';
    let productUrlParams = `?key=${addonProduct.key}&country=${catalogModule.getSelectedCountry()}&country_name=${catalogModule.getSelectCtryName()}&region=${catalogModule.getSelectedReg()}`;
    let showDescCredit = addonProduct.credit ? addonProduct.credit.substring(0, 100): '';
    let moreDescCredit = addonProduct.credit ? addonProduct.credit.substring(100, addonProduct.credit.length+1) : '';

    let showDesc = addonProduct.description ? addonProduct.description.substring(0, 100): '';
    let moreDesc = addonProduct.description ? addonProduct.description.substring(100, addonProduct.description.length+1) : '';
    let isPckgFree = addonProduct.type !== "free" && addonProduct.hasOwnProperty("included_in_pkg") && addonProduct.included_in_pkg !== "not_included";

    function showMore(){
        setShowText(true);
    }

    function showProduct(data) {
        setAddonProduct(data);
        setLoading(false);
    }

    React.useEffect(() => {
        setLoading(true);
        showProduct(props.product);
        // catalog_interface.getBundleForKey(data, (data)=> showProduct(data));
    }, []);
    let renderImage = "";
    if(addonProduct.hasOwnProperty("thumbnailURL") && addonProduct.thumbnailURL){
        renderImage = addonProduct.thumbnailURL;
    } else if(addonProduct.hasOwnProperty("thumbnailurl") && addonProduct.thumbnailurl){
        renderImage = addonProduct.thumbnailurl;
    } else {
        renderImage = catalogModule.getUrl("static_na_product");
    }
    return (
        <div className="product-card">
            <div className="product-image">
                <ImageLoader key={addonProduct.key}
                             src={renderImage}
                             alt={addonProduct.name}
                             width={'128'}
                             height={'130'}
                             skelWidth={'128px'}
                             skelHeight={'130px'}/>
                {/*{ isLoading && <SkeletonLoader width={'128px'} height={'130px'}/> }*/}
                {/*{ !isLoading && <img key={addonProduct.key} src={renderImage} alt={addonProduct.name} width="128" height="130" /> }*/}
            </div>
            <div className="product-body">
                <div className={`product-content ${showText ? 'has-more-content' : ''}`}>
                    <div className="product-content-header">
                        { isLoading && <SkeletonLoader width={'90%'} height={'30px'}/>}
                        { !isLoading && catalog_data.app_theme === "services" && <h5><a onClick={(e) => show_spinner(e, null, catalogModule.getUrl("bundle_view") + productUrlParams)} >{addonProduct.name}</a></h5> }
                        { !isLoading && catalog_data.app_theme === "manager" && <h5><a className="no-link">{addonProduct.name}</a></h5> }
                        { (addonProduct.featured || addonProduct.featured === 0) && <img src={staticFeature} alt="featured_product"/> }
                    </div>
                    {
                        addonProduct.type && addonProduct.type !== "non-consumable" && addonProduct.type !== "consumable" ? <p className="product-type">{addonProduct.type}</p> : ''
                    }

                    { isLoading && <SkeletonLoader width={'60%'} height={'20px'}/> }
                    {
                        !isLoading && <p>
                            <i className="product-price">{productObj && productObj.temp_price ? productObj.temp_price : ''} {addonProduct.type === 'consumable' ? '/credit ' : ''}</i>
                            <i className="product-price-tax">{productObj && productObj.tax_info ? productObj.tax_info : ''}</i>
                        </p>
                    }
                    {
                        !isLoading && <p>
                            <i className="product-price-sub">{isPckgFree && freeAddonText}</i>
                        </p>
                    }

                    { isLoading && <SkeletonLoader width={'75%'} height={'50px'}/> }
                    {
                        !isLoading && addonProduct.hasOwnProperty('credit') && addonProduct.credit.length > 100 ?
                            <p>
                                {showDescCredit}
                                {showText ? '' : <span className="more_btn"
                                                       onClick={() => showMore()}>...{readMoreText}</span>}
                                {showText ? <span>{moreDescCredit}</span> : ''}
                            </p>
                            :   <p>{addonProduct.credit}</p>
                    }

                    {  isLoading && <SkeletonLoader width={'70%'} height={'25px'}/>}
                    {
                        !isLoading && addonProduct.hasOwnProperty('description') && addonProduct.description.length > 100 ?
                            <p>
                                {showDesc}
                                {showText ? '' : <span className="more_btn"
                                                       onClick={showMore}>...{readMoreText}</span>}
                                {showText ? <span>{moreDesc}</span> : ''}
                            </p>
                            : <p>{addonProduct.description}</p>
                    }
                </div>
                {/*{productInfo && productInfo.package_credit ? <p className="package-info">{productInfo.package_credit}</p> : ''}*/}
                <div className="product-footer">
                    { !isLoading && <CountryProductButton {...props} 
                                                          product={addonProduct} 
                                                          isPckgFree={isPckgFree}/> }
                </div>
            </div>
        </div>
    )
};

export default CountryProduct;
